import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import * as R from "ramda";
import moment from "moment-timezone";

import Button from "../../../../../../../components/Button";
import Element from "../../../../../../../components/structure/Element";
import Search from "../../../../../../../components/transforms/Search";
import { ConditionalWrapper } from "../../../../../../../components/ConditionalWrapper";

import Create from "./Create";
import List from "./List";

import styled from "styled-components/macro";

const AddButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  .add-room-btn {
    margin-left: 20px;
    width: calc(100% - 20px);
    max-width: 150px;
    order: 1;
  }
  .list-room {
    order: 2;
    flex-grow: 1;
    summary {
      font-weight: bold;
      cursor: pointer;
    }
    ul {
      list-style: none;
      padding: 0;
    }
  }
  > div:first-of-type {
    flex: 1 1 520px;
  }
  .ant-input {
    height: 40px;
  }
  .ant-list {
    width: 100%;
  }
  .ant-list-item {
    padding: 5px;
  }
`;

const Rooms = ({ t, value, onChange, ...props }) => {
  const [showCreateModal, toggleCreateModal] = useState(false);

  const rooms = R.pipe(R.sortBy(R.prop("start")))(value);

  function closeModal() {
    toggleCreateModal(false);
  }

  function handleCancel() {
    closeModal();
  }

  function handleAdd(room) {
    onChange(R.append(R.assoc("isNew", true, room), rooms));
    closeModal();
  }

  function handleRemove(id) {
    onChange(
      R.map(R.when(R.propEq("id", id), R.assoc("isDeleted", true)), rooms)
    );
    closeModal();
  }

  const showData = data => {
    const [past, future] = R.partition(
      x => moment(x.end).isBefore(moment(), "day"),
      data
    );
    return (
      <div className="list-room">
        {past.length > 0 && (
          <details>
            <summary>{t("opportunity:process.rooms.past")}</summary>
            <List data={past} onRemove={handleRemove} />
          </details>
        )}
        <ConditionalWrapper
          condition={past.length > 0}
          trueWrapper={children => (
            <details open>
              <summary>{t("opportunity:process.rooms.future")}</summary>
              {children}
            </details>
          )}
        >
          <List data={future} onRemove={handleRemove} />
        </ConditionalWrapper>
      </div>
    );
  };

  return (
    <Element {...props}>
      <AddButtonContainer>
        <Search data={R.reject(R.propEq("isDeleted", true), rooms)}>
          {showData}
        </Search>
        <Button
          block
          icon="plus"
          type="quaternary"
          className="add-room-btn"
          onClick={() => toggleCreateModal(true)}
        >
          {t("opportunity:process.rooms.addRoom")}
        </Button>
      </AddButtonContainer>
      {showCreateModal && (
        <Create
          isLoading={false}
          onSubmit={handleAdd}
          onCancel={handleCancel}
        />
      )}
    </Element>
  );
};

export default withTranslation(["global", "opportunity"])(Rooms);
